<error-dialog [visible]="visible()" [title]="title()" (onClose)="onClosedDialog()">
  <div>
    @for (line of message(); track $index) {
    <p>{{line}}</p>
    }
  </div>
</error-dialog>
